__turbopack_context__.v({
  "link_block": "_4_e9Nq_link_block",
  "link_block__content": "_4_e9Nq_link_block__content",
  "link_block__link": "_4_e9Nq_link_block__link",
});
